import { ButtonBase, styled } from "@mui/material";

const PREFIX = "PaperCandidateChallengeActionCard";

export const paperCandidateChallengeActionCardClasses = {
  root: `${PREFIX}-root`,
  todo: `${PREFIX}-todo`,
  done: `${PREFIX}-done`,
  late: `${PREFIX}-late`,
  missed: `${PREFIX}-missed`,
  icon: `${PREFIX}-icon`,
};

export const PaperCandidateChallengeActionCardRoot = styled(ButtonBase)(({ theme }) => ({
  [`&.${paperCandidateChallengeActionCardClasses.root}`]: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: "4px",
    "&:hover:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.action.hover,
    },
  },
  [`&.${paperCandidateChallengeActionCardClasses.todo}`]: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
  [`&.${paperCandidateChallengeActionCardClasses.done}`]: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
  },
  [`&.${paperCandidateChallengeActionCardClasses.late}`]: {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
  },
  [`&.${paperCandidateChallengeActionCardClasses.missed}`]: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.gray.dark,
  },
  [`& .${paperCandidateChallengeActionCardClasses.icon}`]: {
    fontSize: "12px",
  },
}));
